enum TotalsTableBorderType {
  BillingPeriod = 'BillingPeriod',
  WeekTotals = 'WeekTotals'
}

export default TotalsTableBorderType;
